import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Input, Nav, NavItem, NavLink } from 'reactstrap';
import { partial } from '../../../util/translation/translation';
import { REPORT_PERIODS, periodRange } from '../connect';

const DATE = 'YYYY-MM-DD';

/**
 * The report's period: a quick choice, or dates of its own. The value is
 * { period, from, to } with moments, `to` not included (the dates shown
 * include the last day).
 */
const ConnectPeriodPicker = ({ value, onChange }) => {
  const p = partial('connect');
  const setDates = (from, toIncluded) => {
    const start = moment(from, DATE, true);
    const end = moment(toIncluded, DATE, true);
    if (start.isValid() && end.isValid() && !end.isBefore(start)) {
      onChange({ period: 'custom', from: start, to: end.add(1, 'day') });
    }
  };
  const lastDay = value.to.clone().subtract(1, 'day');

  return (
    <div className="d-flex flex-wrap align-items-center mb-3">
      <Nav pills className="mr-3">
        {REPORT_PERIODS.map((period) => (
          <NavItem key={period}>
            <NavLink
              role="button"
              active={value.period === period}
              onClick={() => onChange({ period, ...periodRange(period) })}
            >
              {p(`period-${period}`)}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <div className="d-flex align-items-center">
        <Input
          type="date"
          bsSize="sm"
          aria-label={p('periodFrom')}
          value={value.from.format(DATE)}
          onChange={(e) => setDates(e.target.value, lastDay.format(DATE))}
        />
        <span className="mx-2">–</span>
        <Input
          type="date"
          bsSize="sm"
          aria-label={p('periodTo')}
          value={lastDay.format(DATE)}
          onChange={(e) => setDates(value.from.format(DATE), e.target.value)}
        />
      </div>
    </div>
  );
};

ConnectPeriodPicker.propTypes = {
  value: PropTypes.shape({
    period: PropTypes.string.isRequired,
    from: PropTypes.object.isRequired,
    to: PropTypes.object.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ConnectPeriodPicker;
